import { datadogRum } from "@datadog/browser-rum"
import { scrubRumUrl } from "./datadog_rum_url"
import { writeRumSessionCookie } from "./rum_session_cookie"

const readRumConfig = () => {
  const content = document.querySelector('meta[name="datadog-rum"]')?.content
  return content && JSON.parse(content)
}

const scrubUrls = (event) => {
  event.view.url = scrubRumUrl(event.view.url)
  event.view.referrer = scrubRumUrl(event.view.referrer)
  if (event.resource) event.resource.url = scrubRumUrl(event.resource.url)
  if (event.error?.resource) event.error.resource.url = scrubRumUrl(event.error.resource.url)
  return true
}

const beforeSend = (event) => {
  writeRumSessionCookie(event)
  return scrubUrls(event)
}

const initRum = (initOptions) => {
  datadogRum.init({
    ...initOptions,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: "mask",
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // [WHY] The auth flow can render inside a customer's iframe, where a first-party cookie is dropped.
    usePartitionedCrossSiteSessionCookie: true,
    // [WHY] Users move between auth.*, app.* and link.*; one cookie on the parent domain keeps a single session.
    trackSessionAcrossSubdomains: true,
    beforeSend,
  })
}

// Turbo swaps the meta tag without re-running this module, e.g. signing in moves from no org to an org.
const syncRumConfig = () => {
  const rumConfig = readRumConfig()
  if (!rumConfig) return

  if (!datadogRum.getInitConfiguration()) initRum(rumConfig.init)
  datadogRum.setGlobalContext(rumConfig.globalContext)
}

syncRumConfig()
document.addEventListener("turbo:load", syncRumConfig)
